import React, { useEffect } from 'react';
import './App.css';
import './Privacy.css';
import './Careers.css';
import { CAREERS_EMAIL, ROLES } from './careersData';

function CareerRole({ roleId }) {
  const currentYear = new Date().getFullYear();
  const role = ROLES.find((r) => r.id === roleId);

  useEffect(() => {
    document.title = `${role ? role.title : 'Role not found'} | Careers | Walk It Off`;
    window.scrollTo(0, 0);
  }, [role]);

  return (
    <div className="App">
      <nav className="nav">
        <a href="/" className="logo-container" aria-label="Walk It Off home">
          <img
            src="/walkitofflogo-dark.svg"
            alt="Walk It Off"
            className="logo-horizontal"
            width="350"
            height="130"
          />
        </a>
        <a href="https://apps.apple.com/us/app/walk-it-off-daily-walk-habit/id6818257483" className="nav-cta privacy-nav-cta" target="_blank" rel="noopener noreferrer">
          Download
        </a>
      </nav>

      <main className="privacy-page">
        <div className="privacy-container">
          <a href="/careers" className="careers-back-top">← All open roles</a>

          {role ? (
            <>
              <h1 className="privacy-title">{role.title}</h1>
              <p className="careers-meta">{role.meta.join(' · ')}</p>

              <h2>The role</h2>
              {role.summary.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              <h2>What you'll do</h2>
              <ul>
                {role.responsibilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <h2>What we're looking for</h2>
              <ul>
                {role.requirements.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <h2>How we'll measure success</h2>
              <ul>
                {role.milestones.map(([when, what]) => (
                  <li key={when}>
                    <strong>{when}:</strong> {what}
                  </li>
                ))}
              </ul>

              <h2>How to apply</h2>
              <p>
                {role.apply} Email{' '}
                <a href={`mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(`Application: ${role.title}`)}`}>
                  {CAREERS_EMAIL}
                </a>{' '}
                with the subject line "Application: {role.title}".
              </p>
              <p className="careers-closer">{role.closer}</p>
            </>
          ) : (
            <>
              <h1 className="privacy-title">Role not found</h1>
              <p>
                This role may have been filled or the link is out of date.{' '}
                <a href="/careers">See all open roles</a>.
              </p>
            </>
          )}

          <a href="/careers" className="privacy-back">← Back to Careers</a>
        </div>
      </main>

      <footer className="footer">
        <div className="footer-bottom">
          <span>walkitoff.xyz</span>
          <span>© {currentYear} Walk It Off. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}

export default CareerRole;
